import { AuthLoginResponseProps, ITokenService } from '@watcherr/resources';
import PersistentStoreService from './PersistentStoreService';

const STORAGE_KEY = 'tequinity.tokenData';

class TokenService implements ITokenService {
  token?: AuthLoginResponseProps;
  baseUrl = {
    apiUrl: import.meta.env.VITE_RESOURCE_API_URL || '',
    wsUrl: import.meta.env.VITE_RESOURCE_WS_URL || '',
  };

  async getAuthResponse(): Promise<AuthLoginResponseProps> {
    if (!this.token) {
      this.token = PersistentStoreService.get<AuthLoginResponseProps>(STORAGE_KEY);
    }
    if (this.token) {
      return this.token;
    } else {
      throw new Error('TokenService: Failed to retrieve auth response');
    }
  }

  async setAuthResponse(token: AuthLoginResponseProps) {
    this.token = token;
    PersistentStoreService.set(STORAGE_KEY, token);
  }

  getBaseUrl(): Promise<{ apiUrl: string; wsUrl: string }> {
    return Promise.resolve(this.baseUrl);
  }

  async clear() {
    this.token = undefined;
    // PersistentStore is cleared seperatly
  }
}
export default new TokenService();
